import { LegalLayout } from "@/components/LegalLayout";

const Escrow = () => (
  <LegalLayout
    title="Escrow Terms"
    description="How Cash Isle holds and releases gig funds."
    updated="May 14, 2026"
  >
    <p>
      When a gig is posted, the full budget is debited from the poster's wallet
      and held by Cash Isle in a non-interest-bearing escrow ledger until the
      gig is resolved. Escrow is not a deposit account, is not insured, and
      does not earn interest for either party.
    </p>

    <h2>Lifecycle</h2>
    <ol>
      <li><strong>Hold:</strong> Funds are debited from the poster and locked when a gig is created.</li>
      <li><strong>Assignment:</strong> The poster accepts a worker. Funds remain held.</li>
      <li><strong>Proof of work:</strong> The worker submits proof (media, GPS, notes). The dispute window opens.</li>
      <li><strong>Release:</strong> Poster approves, or the dispute window expires without a dispute, and funds are credited to the worker.</li>
      <li><strong>Refund:</strong> The gig is cancelled before assignment, or a dispute resolves in the poster's favour, and funds are returned to the poster.</li>
      <li><strong>Split:</strong> An admin may release part of the budget to the worker and refund the remainder to the poster.</li>
    </ol>

    <h2>Dispute window</h2>
    <p>
      After proof submission the poster has a fixed window (currently 48 hours,
      shown in-app on the gig screen) to approve, request changes, or open a
      dispute. If no action is taken, the gig auto-approves and funds release
      to the worker.
    </p>

    <h2>Fees</h2>
    <p>
      Cash Isle may charge a platform fee on the released amount. Any fee is
      shown to both parties before the gig is accepted. No hidden deductions
      are taken from escrowed funds.
    </p>

    <h2>Tier limits</h2>
    <p>
      Maximum gig budgets and daily payout limits depend on your verification
      tier. Higher limits require additional KYC. Limits are listed on the gig
      creation screen and in your wallet.
    </p>

    <h2>Frozen wallets</h2>
    <p>
      If either party's wallet is frozen for fraud review, escrow on affected
      gigs is paused until review completes. Disputes filed during a freeze
      remain open and are reviewed by our team.
    </p>

    <h2>Failure & reversal</h2>
    <p>
      If we determine that a gig was used to launder funds, defraud a
      counterparty, or violate our Acceptable Use Policy, we may reverse the
      escrow, claw back released funds, and report to authorities. Decisions
      are at our sole discretion.
    </p>

    <h2>Governing terms</h2>
    <p>
      These Escrow Terms incorporate by reference the{" "}
      <a href="/legal/terms">Terms of Service</a>,{" "}
      <a href="/legal/disputes">Dispute Policy</a>, and{" "}
      <a href="/legal/refunds">Refund &amp; Reversal Policy</a>.
    </p>
  </LegalLayout>
);

export default Escrow;
